import { useState } from "react";
import { toast } from "react-hot-toast";
import { SIGNING_URL } from "../../api/endpoints";

const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

const CLOUDINARY_CLOUD_NAME = "dtxi4419u";
// const CLOUDINARY_UPLOAD_PRESET = import.meta.env.VITE_CLOUDINARY_UPLOAD_PRESET;

const FileUpload = ({ label, subtext, onFileUpload, accept = ".pdf" }) => {
  const [uploading, setUploading] = useState(false);
  const [uploadedUrl, setUploadedUrl] = useState(null);
  const [fileName, setFileName] = useState(null);

  const validateFile = (file) => {
    if (!file) throw new Error("No file selected");
    if (file.type !== "application/pdf") throw new Error("Please upload a PDF");
    if (file.size > MAX_FILE_SIZE) throw new Error("File size exceeds 10MB limit");
  };

  const getSignature = async (folder) => {
    try {
      const res = await fetch(SIGNING_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({}),
      });

      const data = await res.json();
      return { ...data };
    } catch (err) {
      throw new Error("Failed to get signature from backend");
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      validateFile(file);
      setUploading(true);
      setFileName(file.name);

      const folder = "coe_reports";
      const { signature, timestamp } = await getSignature(folder);

      const formData = new FormData();
      formData.append("file", file);
      formData.append("timestamp", timestamp);
      formData.append("signature", signature);
      formData.append("api_key", "369581437485544");
      formData.append("folder", folder);

      const res = await fetch(`https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/raw/upload`, {
        method: "POST",
        body: formData,
      });

      const result = await res.json();

      if (result.secure_url) {
        setUploadedUrl(result.secure_url);
        onFileUpload(result.secure_url);
        toast.success("File uploaded successfully!");
      } else {
        throw new Error("Upload failed — no secure URL returned.");
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
      setUploading(false);
      e.target.value = ""; // Reset input
    }
  };

  const handleReset = () => {
    setUploadedUrl(null);
    setFileName(null);
  };

  return (
    <div className="mb-4">
      <label className="block text-sm font-bold text-gray-700 mb-2">
        {label}
        {subtext && <span className="ml-2 text-xs text-gray-500">{subtext}</span>}
      </label>

      {!uploadedUrl ? (
        <>
          <input
            type="file"
            onChange={handleFileChange}
            accept={accept}
            disabled={uploading}
            className="w-full p-2 border rounded focus:outline-none focus:border-primary"
          />
          {uploading && <p className="text-sm text-gray-500 mt-1">Uploading...</p>}
        </>
      ) : (
        <div className="bg-green-50 p-3 rounded border border-green-300 mt-2">
          <p className="text-green-700 text-sm font-medium">✅ File uploaded:</p>
          <a
            href={uploadedUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="block text-blue-600 underline break-all mt-1"
          >
            {fileName}
          </a>
          <button
            onClick={handleReset}
            className="mt-2 text-sm text-red-500 hover:underline"
          >
            Upload another file
          </button>
        </div>
      )}
    </div>
  );
};

export default FileUpload;
